/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import Logo from './Logo';
import getDemoLink from '../utils/helpers';
import './Header.scss';

const AddHeaderToComponent = (Component, darkMode, props, startFixed, peacock) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const fixedHeader = !peacock && scrollPosition > 30;
  const isTransparent = peacock || (darkMode && !fixedHeader);

  return (
    <>
      <div
        className={`nav-header ${fixedHeader || startFixed ? 'fixedHeader' : ''} ${peacock ? 'peacock' : ''} 
        ${isTransparent ? 'transparent' : ''}`}>
        <a href="https://www.upshow.tv/" className="logo">
          <Logo darkMode={isTransparent} />
        </a>
        <nav id="desktop-main-menu" className={`header-primary-secondary ${!isTransparent ? 'black-letters' : ''}`}>
          <div className="header-primary">
            {!peacock && (
              <ul className="menu">
                <li
                  id="menu-item-5352"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item menu-item-5352 menu-item-has-children">
                  <a href="https://www.upshow.tv/platform/" tabIndex="0">
                    <span>Platform</span>
                  </a>
                </li>
                <li
                  id="menu-item-3966"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item menu-item-3966 menu-item-has-children">
                  <a href="https://www.upshow.tv/product/" tabIndex="0">
                    <span>Product</span>
                  </a>
                </li>
                <li
                  id="menu-item-5420"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item menu-item-5420 menu-item-has-children">
                  <a href="https://www.upshow.tv/solutions/" tabIndex="0">
                    <span>Solutions</span>
                  </a>
                </li>
                <li
                  id="menu-item-505"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item menu-item-505 menu-item-has-children">
                  <a href="https://www.upshow.tv/resources/" tabIndex="0">
                    <span>Resources</span>
                  </a>
                </li>
                <li
                  id="menu-item-506"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item menu-item-506 menu-item-has-children">
                  <a href="https://www.upshow.tv/company/" tabIndex="0">
                    <span>Company</span>
                  </a>
                </li>
                <li
                  id="menu-item-264"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item menu-item-264 show-active">
                  <a href="/" tabIndex="0">
                    <span>Pricing</span>
                  </a>
                </li>
              </ul>
            )}
          </div>
          <div className="header-secondary">
            <ul className="menu">
              {!peacock && (
                <>
                  <li
                    id="menu-item-14"
                    className="login menu-item menu-item-type-custom menu-item-object-custom menu-item menu-item-14">
                    <a href="https://manager.upshow.tv/login" tabIndex="0">
                      <span>Login</span>
                    </a>
                  </li>
                  <li id="menu-item-5" className="menu-item menu-item-type-custom menu-item-object-custom menu-item menu-item-5">
                    <form className="menu-search-form" method="get" action="https://www.upshow.tv/" role="search">
                      <label htmlFor="menu-search-63c6b38a5c269">
                        <svg width="24" height="24" viewBox="0 0 24 24" fillRule="evenodd">
                          <title>Search</title>
                          <path
                            fill={`${!isTransparent ? 'black' : 'white'}`}
                            d="M23.809 21.646l-6.205-6.205c1.167-1.605 1.857-3.579 1.857-5.711 0-5.365-4.365-9.73-9.731-9.73-5.365 0-9.73 4.365-9.73 9.73 0 5.366 4.365 9.73 9.73 9.73 2.034 0 3.923-.627 5.487-1.698l6.238 6.238 2.354-2.354zm-20.955-11.916c0-3.792 3.085-6.877 6.877-6.877s6.877 3.085 6.877 6.877-3.085 6.877-6.877 6.877c-3.793 0-6.877-3.085-6.877-6.877z"
                          />
                        </svg>
                        <span className="screen-reader-text">Search</span>
                      </label>
                      <input id="menu-search-63c6b38a5c269" name="s" type="search" placeholder="Search..." tabIndex="0" />
                    </form>
                  </li>
                </>
              )}
              <li
                id="menu-item-6021"
                className="demo-btn menu-item menu-item-type-post_type menu-item-object-page menu-item menu-item-6021">
                <a href={getDemoLink(peacock)} tabIndex="0">
                  <span>GET A DEMO</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <div className={`component-container ${fixedHeader ? 'push-body' : ''}`}>
        <Component {...props} />
      </div>
    </>
  );
};
export default AddHeaderToComponent;
